<script lang="ts" setup>
import { ElDropdown, ElDropdownMenu, ElDropdownItem } from 'element-plus';
/*---------------------------------------------
/  PROPS & EMITS
---------------------------------------------*/
/*---------------------------------------------
/  VARIABLES
---------------------------------------------*/
const mobileNavigationOpen = ref<boolean>(false);
const userStore = useUserStore();
const router = useRouter();
const route = useRoute();
const logo = new URL('@/assets/img/panel_logo.png', import.meta.url);
/*---------------------------------------------
/  METHODS
---------------------------------------------*/
const logout = async () => {
	await userStore.logout().then(() => {
		router.push({
			path: '/login',
			force: true,
		});
	});
};
/*---------------------------------------------
/  COMPUTED
---------------------------------------------*/
/*---------------------------------------------
/  WATCHERS
---------------------------------------------*/
/*---------------------------------------------
/  CREATED
---------------------------------------------*/
/*---------------------------------------------
/  HOOKS
---------------------------------------------*/
</script>
<template>
	<header>
		<!-- DESKTOP MENU -->
		<nav class="navbar navbar-expand-lg | desktop-navigation">
			<div class="w-100 d-flex justify-content-between">
				<img
					:src="logo.href"
					class="header-logo d-block d-lg-none">
				<button
					class="navbar-toggler ms-auto"
					type="button"
					data-bs-toggle="collapse"
					data-bs-target="#navbarSupportedContent"
					aria-controls="navbarSupportedContent"
					aria-expanded="false"
					aria-label="Toggle navigation"
					v-if="userStore.user"
					@click="mobileNavigationOpen = !mobileNavigationOpen">
					<span class="navbar-toggler-icon"></span>
				</button>
				<img
					v-if="!userStore.user"
					:src="logo.href"
					class="header-logo mt-3 mb-3">
				<div
					class="collapse navbar-collapse d-none d-lg-block"
					id="navbarSupportedContent">
					<ul
						class="navbar-nav me-auto mb-2 mb-lg-0 align-items-center"
						v-if="userStore.user">
						<li class="">
							<router-link to="/">
								<img
									:src="logo.href"
									class="header-logo">
							</router-link>
						</li>
						<li
							class="nav-item me-3"
							v-if="userStore.user?.data.role === 'user'">
							<router-link
								class="nav-link"
								:class="(route.name === 'user-surveys' || route.name === 'user-survey-fill' || route.name === 'user-survey-show') && 'active'"
								to="/user/surveys">
								Kérdőívek
							</router-link>
						</li>
						<li class="nav-item">
							<router-link
								class="nav-link"
								:class="route.name === 'message-threads' && 'active'"
								to="/message-threads">
								Üzenetek 
								<div
									class="unread-message d-inline-flex align-items-center justify-content-center"
									v-if="userStore.user.data.num_unseen_messages">
									{{ userStore.user.data.num_unseen_messages }}
								</div>
							</router-link>
						</li>
						<li
							class="nav-item ms-3"
							v-if="userStore.user?.data.role === 'user'">
							<router-link
								class="nav-link"
								:class="route.name === 'user-my-coupons' && 'active'"
								to="/user/my-coupons">
								Kuponjaim
							</router-link>
						</li>
					</ul>
					<ul
						class="navbar-nav ms-auto mb-2 mb-lg-0 position-relative"
						v-if="userStore.user">
						<ElDropdown
							hide-on-click
							v-if="userStore.user?.data.role !== 'user'"
							class="d-flex align-items-center me-4"
							trigger="click"
							placement="bottom-end">
							<span class="dropdown-menu-item">
								<div class="d-flex align-items-center">
									<span class="nav__icon">
										<span></span>
										<span></span>
										<span></span>
									</span>
									Adminisztráció
								</div>
							</span>
							<template #dropdown>
								<ElDropdownMenu v-if="userStore.user?.data.role === 'admin'">
									<router-link
										class="nav-link"
										:class="route.name === 'users' && 'active'"
										to="/users">
										<ElDropdownItem>
											Felhasználók
										</ElDropdownItem>
									</router-link>
									<router-link
										class="nav-link"
										:class="route.name === 'user-groups' && 'active'"
										to="/user-groups">
										<ElDropdownItem>
											Felhasználói csoportok
										</ElDropdownItem>
									</router-link>
									<router-link
										class="nav-link"
										:class="route.name === 'invite-codes' && 'active'"
										to="/invite-codes">
										<ElDropdownItem>
											Meghívó kódok
										</ElDropdownItem>
									</router-link>
									<router-link
										class="nav-link"
										:class="route.name === 'survey-list' && 'active'"
										to="/survey/list">
										<ElDropdownItem>
											Kérdőívek
										</ElDropdownItem>
									</router-link>
									<router-link
										class="nav-link"
										:class="route.name === 'coupons' && 'active'"
										to="/coupons">
										<ElDropdownItem>
											Kuponok
										</ElDropdownItem>
									</router-link>
								</ElDropdownMenu>
								<ElDropdownMenu v-if="userStore.user?.data.role === 'contact'">
									<router-link
										class="nav-link"
										:class="route.name === 'contact-users' && 'active'"
										to="/contact/users">
										<ElDropdownItem>
											Felhasználóim
										</ElDropdownItem>
									</router-link>
									<router-link
										class="nav-link"
										:class="route.name === 'contact-survey' && 'active'"
										to="/contact/survey">
										<ElDropdownItem>
											Kérdőíveim
										</ElDropdownItem>
									</router-link>
								</ElDropdownMenu>
							</template>
						</ElDropdown>
						<ElDropdown
							class="d-flex align-items-center justify-content-center position-relative | profile"
							trigger="click"
							placement="bottom-end">
							<div
								class="profile-inner">
								{{ userStore.user?.data?.full_name.split(" ").map((n) => n[0]).join("") }}
							</div>
							<template #dropdown>
								<ElDropdownMenu>
									<router-link
										class="nav-link"
										:class="route.name === 'profile' && 'active'"
										to="/profile">
										<ElDropdownItem>
											Fiókbeállítások
										</ElDropdownItem>
									</router-link>
									<router-link
										class="nav-link"
										to="/"
										@click="logout()">
										<ElDropdownItem>
											Kijelentkezés
										</ElDropdownItem>
									</router-link>
								</ElDropdownMenu>
							</template>
						</ElDropdown>
					</ul>
				</div>
			</div>
		</nav>
		<!-- MOBILE MENU -->
		<transition name="menu-up">
			<nav
				class="navbar align-items-start | mobile-navigation d-block d-lg-none"
				:data-isOpen="mobileNavigationOpen"
				v-if="mobileNavigationOpen">
				<div class="container justify-content-start">
					<ul class="navbar-nav me-auto mb-2 mb-lg-0">
						<li class="nav-item">
							<router-link
								class="nav-link"
								:class="route.name === 'message-threads' && 'active'"
								to="/message-threads">
								Üzenetek
							</router-link>
						</li>
					</ul>
					<!-- USER -->
					<ul
						class="navbar-nav me-auto mb-2 mb-lg-0"
						v-if="userStore.user?.data.role === 'user'">
						<li class="nav-item">
							<router-link
								class="nav-link"
								:class="(route.name === 'user-surveys' || route.name === 'user-survey-fill' || route.name === 'user-survey-show') && 'active'"
								to="/user/surveys">
								Kérdőívek
							</router-link>
						</li>
						<li class="nav-item">
							<router-link
								class="nav-link"
								:class="route.name === 'user-my-coupons' && 'active'"
								to="/user/my-coupons">
								Kuponjaim
							</router-link>
						</li>
					</ul>
					<!-- ADMIN -->
					<ul
						class="navbar-nav me-auto mb-2 mb-lg-0"
						v-if="userStore.user?.data.role === 'admin'">
						<li class="nav-item">
							<router-link
								class="nav-link"
								:class="route.name === 'users' && 'active'"
								to="/users">
								Felhasználók
							</router-link>
						</li>
						<li class="nav-item">
							<router-link
								class="nav-link"
								:class="route.name === 'user-groups' && 'active'"
								to="/user-groups">
								Felhasználói csoportok
							</router-link>
						</li>
						<li class="nav-item">
							<router-link
								class="nav-link"
								:class="route.name === 'invite-codes' && 'active'"
								to="/invite-codes">
								Meghívó kódok
							</router-link>
						</li>
						<li class="nav-item">
							<router-link
								class="nav-link"
								:class="route.name === 'survey-list' && 'active'"
								to="/survey/list">
								Kérdőívek
							</router-link>
						</li>
						<li class="nav-item">
							<router-link
								class="nav-link"
								:class="route.name === 'coupons' && 'active'"
								to="/coupons">
								Kuponok
							</router-link>
						</li>
					</ul>
					<!-- CONTACT -->
					<ul
						class="navbar-nav me-auto mb-2 mb-lg-0"
						v-if="userStore.user?.data.role === 'contact'">
						<li class="nav-item">
							<router-link
								class="nav-link"
								:class="route.name === 'contact-users' && 'active'"
								to="/contact/users">
								Felhasználóim
							</router-link>
						</li>
						<li class="nav-item">
							<router-link
								class="nav-link"
								:class="route.name === 'contact-survey' && 'active'"
								to="/contact/survey">
								Kérdőíveim
							</router-link>
						</li>
					</ul>

					<!-- SHARED -->
					<ul class="navbar-nav me-auto mb-2 mb-lg-0">
						<li class="nav-item">
							<router-link
								class="nav-link"
								:class="route.name === 'profile' && 'active'"
								to="/profile">
								Fiókbeállítások
							</router-link>
						</li>
						<li class="nav-item">
							<router-link
								class="nav-link"
								to="/"
								@click="logout()">
								Kijelentkezés
							</router-link>
						</li>
					</ul>
				</div>
			</nav>
		</transition>
	</header>
</template>



<style src="./Header.scss" lang="scss" scoped />
